module.exports = __webpack_public_path__ + "c419855930f6517a2f41306b93a5241e.MP3";